/**
 * Phase R UX: silent catch 가시성 도우미
 *
 * 모바일 페이지 다수의 silent `catch (e) {}` 패턴은 graceful degradation 의도이지만
 * 인증 만료 / 네트워크 끊김 / 5xx 등을 사용자가 인지 못 하고 빈 화면을 본 후 떠나는
 * UX 위험이 있음 (mobile UX review H-5).
 *
 * 사용:
 *   try { await api.get(...) } catch (e) { silentLog('loadFoo', e); }
 *
 * 동작:
 * - 개발 환경: console.error 로 출력 (디버깅용)
 * - 401: api.js interceptor 가 처리 (forceLogout) — 여기서는 noop
 * - 5xx: 사용자에게 토스트 안내 (선택)
 * - 그 외: 조용히 로깅만 (graceful)
 */

import { toastError } from './toast';

const isDev = import.meta.env?.DEV;

/**
 * @param {string} context - 어디서 발생했는지 식별 (예: 'MobileRepairForm.loadInfo')
 * @param {Error} error - catch 받은 에러
 * @param {Object} [options]
 * @param {boolean} [options.showToast=false] - 5xx 시 사용자 토스트 노출
 * @param {string} [options.toastMessage] - 커스텀 토스트 메시지
 */
export function silentLog(context, error, options = {}) {
  const { showToast = false, toastMessage } = options;
  const status = error?.response?.status;

  // 401: api.js interceptor 가 강제 로그아웃 처리 — 추가 액션 없음
  if (status === 401) return;

  // dev console.error — 운영에서는 자동 제거 (vite production build console drop)
  if (isDev) {
    console.error(`[silentLog:${context}]`, status ? `HTTP ${status}` : error?.message || error);
  }

  // 5xx + showToast 옵션 시 사용자 알림
  if (showToast && status >= 500) {
    toastError(toastMessage || '서버 응답이 일시적으로 지연되고 있습니다.');
  }
}

export default silentLog;
